<ng-container *ngIf="payoutMethod">
  <ng-container *ngIf="combinedView">
    <ng-container *ngIf="!overlappingProperties || overlappingProperties.length === 0">
      <h2>Edit '{{ payoutMethod | payoutMethodTitle }}'</h2>

      <div fxLayout="column" fxLayoutGap="23px">
        <div>
          <h3>Properties using this Payout method</h3>

          <sbnb-property-selection
            [border]="true"
            [listHeight]="280"
            [selectedProperties]="payoutMethod.property_scope"
            (propertiesChange)="setProperties($event)"></sbnb-property-selection>
        </div>

        <div>
          <sbnb-default-payout-method-option
            [isDefault]="payoutMethod.all_properties"
            (isDefaultChanged)="updateDefaultPayoutMethod($event)"></sbnb-default-payout-method-option>
        </div>

        <div>
          <h3>Nickname</h3>
          <mat-form-field class="fw">
            <input
              matInput
              name="nickname"
              [placeholder]="payoutMethod.provider === PayoutMethodProvider.ADYEN ? '(Optional)' : ''"
              [(ngModel)]="payoutMethod.name" />
          </mat-form-field>
        </div>

        <div fxLayoutAlign="end center" fxLayoutGap="12px">
          <sbnb-button
            *ngIf="payoutMethod.can_delete && !origAllProperties"
            label="Delete"
            type="secondary"
            (clicked)="deletePayoutMethodConfirm(payoutMethod)"></sbnb-button>
          <sbnb-button label="Save" [loading]="saving" (clicked)="checkForOverlappingProperties()"></sbnb-button>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="overlappingProperties?.length > 0">
      <sbnb-property-overlap-warning
        [overlappingProperties]="overlappingProperties"
        (backClicked)="overlappingProperties = []"
        (continueClicked)="savePayoutMethod()"></sbnb-property-overlap-warning>
    </ng-container>
  </ng-container>
</ng-container>
